'use strict';

var Table = require('./Table');
var Column = require('./Column');
var ColumnGroup = require('./ColumnGroup');

Table.Column = Column;
Table.ColumnGroup = ColumnGroup;

module.exports = Table;


/*****************
 ** WEBPACK FOOTER
 ** ./~/.5.2.15@rc-table/lib/index.js
 ** module id = 123
 ** module chunks = 0 1
 **/